// eslint-disable-next-line import/prefer-default-export
export const sendMessageToParent = (message: string) =>
  window.parentIFrame?.sendMessage(message);
